import { CHANGE_MENU_LAYOUT } from './configuration/actions';

// Restore the user's last menu choice on load (falls back to 'side').
const getInitialLayout = () => {
    try {
        const stored = localStorage.getItem('menuLayout');
        return stored === 'top' || stored === 'side' ? stored : 'side';
    } catch (e) {
        return 'side';
    }
};

export default (previousState = getInitialLayout(), { type, payload }) => {
    if (type === CHANGE_MENU_LAYOUT) {
        try {
            localStorage.setItem('menuLayout', payload);
        } catch (e) {
            // ignore storage errors (e.g. private mode)
        }
        return payload;
    }
    return previousState;
};
